var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{attrs:{"disabled":_vm.disabled,"id":_vm.id,"name":_vm.name,"type":_vm.type},domProps:{"checked":_vm.value,"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }